import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import Paths from '../../constants/paths';
import { useHistory } from 'react-router-dom';
import useModal from '../../customHooks/useModal';
import Button from '../../components/Button';
import Input from '../../components/Input';
import { FaTrash, FaPlus, FaSearch } from 'react-icons/fa';
import Table from '../../components/Table';
import Modal from '../../components/Modal';
import Pagination from './../../components/Pagination';
import debounce from 'lodash.debounce';
import translations from '../../translations/de';

const Seats = ({ store }) => {
    const history = useHistory();
    const modalRef = useRef(null);
    const [modal, setModal] = useModal(false, modalRef);
    const [seatID, setSeatID] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        store.getSeats(searchQuery);
    }, [store, store.selectedPage, searchQuery]);

    const handleSeat = (id) => {
        store.selectSeat(id);
        history.push(`/seats/${store.selectedSeat.id}`);
    };

    const onSearchChangeHandler = debounce((e) => {
        store.setSelectedPage(1);
        setSearchQuery(e.target.value);
    }, 500);

    return (
        <>
            <div style={{ marginLeft: '2.5%' }}>
                <Input placeholder={translations.search} onChange={onSearchChangeHandler} />
                <Button
                    label={translations.seat}
                    onClick={() => {
                        store.selectSeat(undefined);
                        history.push(Paths.NEW_SEAT);
                    }}
                >
                    <FaPlus style={{ marginRight: '5px' }} />
                </Button>
            </div>
            <Table
                tablePagination={
                    store.totalPages > 1 && (
                        <Pagination
                            totalPages={store.totalPages}
                            selectedPage={store.selectedPage}
                            onSelectedPageChange={(selected) => store.setSelectedPage(selected)}
                        />
                    )
                }
                tableName={translations.seats}
                columns={[
                    {
                        Header: 'Id',
                        accessor: 'id',
                        Cell: ({ value, row }) => <div>{value}</div>,
                    },
                    {
                        Header: translations.sector,
                        accessor: 'sector_title',
                        Cell: ({ value, row }) => <div>{value}</div>,
                    },
                    {
                        Header: translations.seat_group,
                        accessor: 'seatGroup_title',
                        Cell: ({ value, row }) => <div>{value}</div>,
                    },
                    {
                        Header: translations.row,
                        accessor: 'rowNumber',
                        Cell: ({ value, row }) => <div>{value}</div>,
                    },
                    {
                        Header: translations.num,
                        accessor: 'seatNumber',
                        Cell: ({ value, row }) => <div>{value}</div>,
                    },
                    {
                        Header: translations.original_seat,
                        accessor: 'original',
                        Cell: ({ value, row }) => <div>{value}</div>,
                    },
                    {
                        Header: translations.assigned_seat,
                        accessor: 'assigned',
                        Cell: ({ value, row }) => <div>{value}</div>,
                    },
                    {
                        Header: '',
                        accessor: 'action',
                        Cell: ({ row }) => (
                            <div>
                                <Button
                                    onClick={() => {
                                        handleSeat(row.cells[0].value);
                                    }}
                                    title={translations.show}
                                >
                                    <FaSearch />
                                </Button>
                                <Button
                                    onClick={() => {
                                        setSeatID(row.cells[0].value);
                                        setModal(true);
                                    }}
                                    title={translations.delete}
                                >
                                    <FaTrash />
                                </Button>
                            </div>
                        ),
                    },
                ]}
                data={store.seats.map(
                    ({
                        id,
                        row,
                        num,
                        seat_group,
                        // original,
                        // assigned,
                    }) => {
                        return {
                            id,
                            sector_title: seat_group?.sector?.title,
                            seatGroup_title: seat_group?.title,
                            rowNumber: row,
                            seatNumber: num,
                            // original,
                            // assigned,
                        };
                    },
                )}
            />
            {modal && (
                <Modal
                    title="Delete Seat"
                    ref={modalRef}
                    onClose={() => setModal(false)}
                    maxWidth="400px"
                >
                    <p style={{ color: '#333', marginBottom: '20px' }}>
                        Are you sure you want to delete this seat?
                    </p>
                    <div className="Modal-Controls">
                        <Button
                            label="Yes"
                            onClick={() => {
                                store.deleteSeat(seatID);
                                setModal(false);
                            }}
                            style={{ width: '80px' }}
                        />
                        <Button
                            label="No"
                            onClick={() => setModal(false)}
                            style={{ width: '80px', marginLeft: '20px' }}
                        />
                    </div>
                </Modal>
            )}
        </>
    );
};

export default observer(Seats);
